import ComparisonChart from "@/Components/UI/Branding/ComparisonChart";
import { PaymentFormData } from "@/Components/UI/Onboarding/Client/PaymentForm/PaymentForm";
import { getCoachingEvidenceFaqItem } from "@/Pages/Client/PaymentPage/Partials/PaymentFaqCopy/AdditionalFaqItems/CoachingEvidenceFaqItem";
import { getTakeTheBetFaqItem } from "@/Pages/Client/PaymentPage/Partials/PaymentFaqCopy/AdditionalFaqItems/TakeTheBetFaqItem";
import { HiOutlineSwitchHorizontal } from "react-icons/hi";
import { MdCompare } from "react-icons/md";
import { TbTargetArrow } from "react-icons/tb";

export type FaqItem = {
    slug: string;
    title: string;
    icon: React.ReactNode;
    body: React.ReactNode;
};

export function buildFaqItems(
    paymentFormData: PaymentFormData,
    {
        includeCoachingEvidence = false,
    }: { includeCoachingEvidence?: boolean } = {},
): FaqItem[] {
    const takeTheBetFaqItem = getTakeTheBetFaqItem(paymentFormData);
    const coachingEvidenceFaqItem = includeCoachingEvidence
        ? getCoachingEvidenceFaqItem(paymentFormData)
        : null;

    return [
        {
            slug: "how_does_coaching_work",
            title: "How does coaching work?",
            icon: <TbTargetArrow />,
            body: (
                <>
                    <p>
                        You'll meet 1:1 with your coach for in-depth video
                        sessions. During these sessions you will explore an area
                        together, gain clarity and uncover insights, identify
                        the desired progress, and create an action plan.
                    </p>
                    <p>
                        Between sessions, you and your coach will continue to
                        speak via messaging, emails and text messages. Your
                        coach will provide guidance when challenges arise, keep
                        you motivated and on track, and celebrate every win
                        along the way.
                    </p>
                </>
            ),
        },
        ...(coachingEvidenceFaqItem
            ? [
                  {
                      slug: "coaching_evidence",
                      title: coachingEvidenceFaqItem.title,
                      icon: coachingEvidenceFaqItem.icon,
                      body: coachingEvidenceFaqItem.description,
                  },
              ]
            : []),
        {
            slug: "satisfied_with_coach",
            title: "What if I'm not satisfied with my coach?",
            icon: <HiOutlineSwitchHorizontal />,
            body: (
                <p>
                    We are usually able to find the right coach at the first
                    try. However, if you feel this coach isn't a good fit, you
                    can easily switch to a different one with a few clicks.
                </p>
            ),
        },
        {
            slug: "comparison_to_conventional",
            title: "How does Strawberry.me compare to conventional coaching?",
            icon: <MdCompare />,
            body: (
                <>
                    <p>
                        With Strawberry.me, you get a personalized coach match
                        based on your goals, ongoing support between sessions,
                        and the flexibility to cancel anytime - at a fraction of
                        conventional coaching rates.
                    </p>
                    <ComparisonChart paymentFormData={paymentFormData} />
                </>
            ),
        },
        ...(takeTheBetFaqItem
            ? [
                  {
                      slug: "take_the_bet",
                      title: takeTheBetFaqItem.title,
                      icon: takeTheBetFaqItem.icon,
                      body: takeTheBetFaqItem.description,
                  },
              ]
            : []),
    ];
}
